import React, {
  MouseEvent,
  KeyboardEvent,
} from 'react';
import {
  useSnapActions,
} from 'views/EMR/stores/snap';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MicIcon from 'core/icons/mic';
import clsx from 'clsx';

type Props = {
  recordingState: string;
};

export default function MinimizedSnap({ recordingState }: Props) {
  const { toggleSnapPopover } = useSnapActions();

  const onClick = (e: MouseEvent<HTMLDivElement> | KeyboardEvent<HTMLDivElement>) => {
    toggleSnapPopover(e.currentTarget);
  };

  return (
    <div className="absolute bottom-10 right-10 z-50">
      <div
        role="button"
        tabIndex={0}
        className={clsx(
          'flex items-center bg-gray-700 rounded-full shadow-lg cursor-pointer transition-all duration-300',
          'hover:bg-gray-600 pl-2 pr-4 py-2 overflow-hidden',
        )}
        style={{
          boxShadow: '0 4px 14px 0 rgba(147, 197, 253, 0.4)',
        }}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick(e);
          }
        }}
      >
        {/* Mic container with pulse effects */}
        <div className="relative">
          {/* Ripple effects for recording state - only around mic */}
          {recordingState === 'recording' && (
            <>
              <div
                className="absolute inset-0 rounded-full border-2 border-blue-300 opacity-80"
                style={{
                  animation: 'recordingRipple 2s linear infinite',
                  animationDelay: '0s',
                  transform: 'scale(1.2)',
                }}
              />
              <div
                className="absolute inset-0 rounded-full border-2 border-blue-400 opacity-60"
                style={{
                  animation: 'recordingRipple 2s linear infinite',
                  animationDelay: '0.5s',
                  transform: 'scale(1.4)',
                }}
              />
              <div
                className="absolute inset-0 rounded-full border-2 border-blue-500 opacity-40"
                style={{
                  animation: 'recordingRipple 2s linear infinite',
                  animationDelay: '1s',
                  transform: 'scale(1.6)',
                }}
              />
            </>
          )}
          <div
            className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center relative z-10"
            style={{
              boxShadow: recordingState === 'recording'
                ? '0 0 15px rgba(59, 130, 246, 0.8)'
                : '0 2px 8px rgba(59, 130, 246, 0.3)',
            }}
          >
            <MicIcon
              className={clsx(
                'text-white transition-all duration-300 !w-5 !h-5',
                recordingState === 'recording' && 'scale-110 animate-pulse',
              )}
            />
          </div>
        </div>

        {/* Arrow */}
        <div className="ml-2">
          <KeyboardArrowUpIcon className="text-blue-400 !w-5 !h-5" />
        </div>
      </div>
    </div>
  );
}
